/*
 * This mixin gives the ability to a form-element component to request the population of his value
 * Example: board module editor
 */
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    requestPopulationFrom: {
      type: String,
    },
  },
  computed: {
    canRequestPopulation() {
      return !!this.requestPopulationFrom;
    },
  },
  methods: {
    requestPopulation() {
      this.$emit('request-population', {
        fromField: this.requestPopulationFrom,
        toField: this.name,
      });
    },
  },
};
